import React, { useState, useEffect } from "react";
import DailySection from "./component/dailysection";

const AddDailyPage = ({
  formData,
  handleChange,
  handleCheckboxChange,
  dtDisplay,
}) => {
  // 선택된 Daily 섹션들을 관리하는 state
  const [selectedDailies, setSelectedDailies] = useState([]);
  // 라디오 버튼 전용 핸들러 - 간단한 재클릭 해제 로직
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      // 이미 선택된 상태라면 해제
      handleChange({ target: { name, value: "" } });
    } else {
      // 다른 값이라면 선택
      handleChange({ target: { name, value } });
    }
  };

  // Daily 섹션 선택 핸들러
  const handleDailySelection = (sectionNumber) => {
    setSelectedDailies((prev) => {
      const newSelection = prev.includes(sectionNumber)
        ? prev.filter((num) => num !== sectionNumber)
        : [...prev, sectionNumber].sort((a, b) => a - b);

      // 새로 추가된 Daily 섹션의 필드들 초기화
      if (!prev.includes(sectionNumber)) {
        handleChange({
          target: {
            name: `d${sectionNumber}_status`,
            value: "Not started",
          },
        });

        // 기본 필드들 초기화
        const basicFields = [
          "location",
          "gcs_worst_dt",
          "gcs_worst_asscond",
          "gcs_worst_change24h",
          "gcs_worst_change24h_cause",
          "gcs_worst_e",
          "gcs_worst_v",
          "gcs_worst_m",
          "gcs_worst_total",
          "gcs_best_e",
          "gcs_best_v",
          "gcs_best_m",
          "gcs_best_total",
          "til_summary",
        ];

        basicFields.forEach((field) => {
          handleChange({
            target: {
              name: `d${sectionNumber}_${field}`,
              value: "",
            },
          });
        });
      }

      // what_daily 값 업데이트
      const whatDailyValue =
        newSelection.length > 0
          ? newSelection.map((num) => `Daily${num}`).join(", ")
          : "";

      handleChange({
        target: {
          name: "what_daily",
          value: whatDailyValue,
        },
      });

      return newSelection;
    });
  };

  // 초기 로딩시 what_daily 값이 있다면 선택된 Daily 섹션들을 복원
  useEffect(() => {
    if (formData.what_daily) {
      const dailyNumbers = formData.what_daily
        .split(", ")
        .map((daily) => parseInt(daily.replace("Daily", "")))
        .filter((num) => !isNaN(num));
      setSelectedDailies(dailyNumbers);
    }
  }, []);

  // Daily 4부터 14까지의 배열
  const availableDailies = Array.from({ length: 11 }, (_, i) => i + 4);

  return (
    <section className="vip-form-section">
      {/* Daily 섹션 선택 UI */}
      <div className="basic-info-fieldset">
        <h3 className="section-subtitle">추가할 Daily 섹션 선택</h3>
        <div
          className="daily-selection-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            padding: "20px",
            backgroundColor: "#f5f5f5",
            borderRadius: "5px",
            marginBottom: "20px",
          }}
        >
          {availableDailies.map((number) => (
            <label
              key={number}
              className="checkbox-label"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 12px",
                backgroundColor: selectedDailies.includes(number)
                  ? "#e3f2fd"
                  : "white",
                borderRadius: "4px",
                cursor: "pointer",
                border: "1px solid #ddd",
                transition: "all 0.2s ease",
              }}
            >
              <input
                type="checkbox"
                checked={selectedDailies.includes(number)}
                onChange={() => handleDailySelection(number)}
                style={{ marginRight: "8px" }}
              />
              <span>Daily {number}</span>
            </label>
          ))}
        </div>

        {/* what_daily 값 표시 (읽기 전용, 화면에 보이지 않음) */}
        <div className="input-wrapper-2column" style={{ display: "none" }}>
          <div className="block-2column">
            <label className="item_title_2col">선택된 Daily 섹션</label>
            <div className="input_2col">
              <input
                type="text"
                name="what_daily"
                value={formData.what_daily || ""}
                readOnly
                style={{
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                }}
              />
            </div>
          </div>
          <div className="block-2column" />
        </div>
      </div>

      {/* 선택된 Daily 섹션들 렌더링 */}
      {selectedDailies.map((sectionNumber) => (
        <DailySection
          key={sectionNumber}
          sectionNumber={sectionNumber}
          formData={formData}
          handleChange={handleChange}
          handleCheckboxChange={handleCheckboxChange}
          handleRadioClick={handleRadioClick}
          dtDisplay={dtDisplay}
        />
      ))}

      {/* 선택된 섹션이 없을 때 안내 메시지 */}
      {selectedDailies.length === 0 && (
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            color: "#666",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            margin: "20px 0",
          }}
        >
          <h4>추가할 Daily 섹션을 선택해주세요</h4>
          <p>Daily 4부터 Daily 14까지 원하는 섹션을 선택할 수 있습니다.</p>
        </div>
      )}

      {/* Completion Status_4 필드 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">
            Completion status_4 (additional_daily_status)
          </label>
          <div className="input_2col">
            <div className="rad-group vertical">
              {[
                { label: "Not started", value: "Not started" },
                { label: "In process", value: "In process" },
                { label: "Complete", value: "Complete" },
              ].map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="additional_daily_status"
                    value={option.value}
                    checked={formData.additional_daily_status === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}} // 빈 함수로 React 경고 방지
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="block-2column" />
      </div>
    </section>
  );
};

export default AddDailyPage;
